import { FC, useCallback } from "react";
import { useEffectOnceWhen } from "rooks";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../../store/hooks";
import { costBreakdownSetupPropertyByKeySelector } from "../../../../../../../../../store/dashboards/selectors/setups/cost-breakdown/costBreakdownSetupPropertyByKeySelector";
import { costBreakdownSetupChangeThunk } from "../../../../../../../../../store/dashboards/thunks/widgets/cost-breakdown/costBreakdownSetupChangeThunk";
import { ResourceExplorerGrouping } from "../../../../../../../../../services/cloudchipr.api";
import { GroupBySelector } from "../../../../../../../common/resource-explorer/group-by-selector/GroupBySelector";
import { getResourceExplorerPossibleFiltersByProvidersThunk } from "../../../../../../../../../store/common/thunks/resource-explorer/getResourceExplorerPossibleFiltersByProvidersThunk";
import { resourceExplorerDataGroupingAvailableTagsSelector } from "../../../../../../../../../store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerDataGroupingAvailableTagsSelector";
import { selectedViewProvidersSelector } from "../../../../../../../../../store/dashboards/selectors/widgets/common/SelectedViewProvidersSelector";

interface ResourceExplorerGroupingSelectProps {
  disabled?: boolean;
}
export const ResourceExplorerGroupingSelect: FC<
  ResourceExplorerGroupingSelectProps
> = ({ disabled }) => {
  const dispatch = useAppDispatch();

  const groupBy = useAppSelector(
    costBreakdownSetupPropertyByKeySelector("grouping"),
  );
  const groupValues = useAppSelector(
    costBreakdownSetupPropertyByKeySelector("group_values"),
  );
  const availableTags = useAppSelector(
    resourceExplorerDataGroupingAvailableTagsSelector,
  );
  const providers = useAppSelector(selectedViewProvidersSelector);

  const groupingChangeHandler = useCallback(
    (grouping: ResourceExplorerGrouping, groupValues?: string[]) => {
      dispatch(
        costBreakdownSetupChangeThunk({ grouping, group_values: groupValues }),
      );
    },
    [dispatch],
  );

  useEffectOnceWhen(() => {
    dispatch(getResourceExplorerPossibleFiltersByProvidersThunk(providers));
  }, !!providers.length);

  return (
    <GroupBySelector
      value={groupBy}
      disabled={disabled}
      providers={providers}
      groupValues={groupValues}
      onGroupingChange={groupingChangeHandler}
      groupValueOptions={availableTags ?? undefined}
    />
  );
};
